import Lenis from "lenis";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default class LenisSmooth {
  constructor(options = {}) {
    this.options = Object.assign(
      {
        easing: (t) => t,
        smooth: true,
      },
      options,
    );

    this.lenis = null;
    this._raf = null;
  }

  init() {
    if (this.lenis) return this.lenis;

    this.lenis = new Lenis();

    // expose for other utilities to detect
    if (typeof window !== "undefined") {
      window.__lenis = this.lenis;
      // common choice for scroller element — other code can read this
      window.__lenis_scroller = document.body;
    }

    // ensure ScrollTrigger is available
    try {
      // update ScrollTrigger on Lenis scroll
      this.lenis.on("scroll", () => {
        if (typeof ScrollTrigger !== "undefined" && ScrollTrigger.update)
          ScrollTrigger.update();
      });
    } catch (e) {
      // ignore
    }

    // drive Lenis via GSAP ticker for consistent timing
    this._raf = (time) => {
      // GSAP ticker time is in seconds for some contexts, but Lenis expects ms
      try {
        this.lenis.raf(time * 1000);
      } catch (e) {
        // fallback: call with time directly
        try {
          this.lenis.raf(time);
        } catch (err) {
          // noop
        }
      }
    };

    gsap.ticker.add(this._raf);
    // reduce lag smoothing so Lenis feels responsive
    if (gsap.ticker && typeof gsap.ticker.lagSmoothing === "function")
      gsap.ticker.lagSmoothing(0);

    // let ScrollTrigger recalculate after Lenis initializes
    if (typeof ScrollTrigger !== "undefined" && ScrollTrigger.refresh)
      ScrollTrigger.refresh();

    return this.lenis;
  }

  destroy() {
    if (this._raf && gsap && gsap.ticker) gsap.ticker.remove(this._raf);
    if (this.lenis && typeof this.lenis.destroy === "function")
      this.lenis.destroy();
    if (typeof window !== "undefined") {
      delete window.__lenis;
      delete window.__lenis_scroller;
    }
    this.lenis = null;
    this._raf = null;
  }

  getInstance() {
    return this.lenis;
  }
}
